import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

export default function FarmersSection() {
  return (
    <section id="farmers" className="sun-glaze bg-secondary-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              Meet Our Farmers
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            Behind Every Farm Is a Story
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
            Farmers are not just producers. They are custodians of the land, keepers of knowledge,
            and an essential part of our communities. Through Rythugaru, visitors can meet farmers,
            listen to their stories, understand their work, and experience agriculture from their
            perspective.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {[
            {
              name: "Rajanna",
              slug: "rajanna",
              village: "Konaseema",
              crop: "Paddy & Coconut",
              quote: "Every seed I plant carries the hope of my family.",
            },
            {
              name: "Lakshmi Devi",
              slug: "lakshmi-devi",
              village: "Ravulapalem",
              crop: "Vegetables & Flowers",
              quote: "The soil gives back ten times the love you give it.",
            },
            {
              name: "Venkat Rao",
              slug: "venkat-rao",
              village: "Amalapuram",
              crop: "Banana Plantation",
              quote: "My grandfather's fields are my children's classroom.",
            },
          ].map((farmer, i) => (
            <Reveal key={farmer.name} delay={i * 100}>
              <article className="h-full bg-background-50 rounded-lg border border-secondary-200 p-7 flex flex-col">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-user-star-line text-2xl"></i>
                </span>
                <p className="font-heading text-lg italic text-foreground-800 leading-snug mt-5 flex-1">
                  “{farmer.quote}”
                </p>
                <div className="mt-6 pt-5 border-t border-secondary-200">
                  <p className="font-semibold text-foreground-950">{farmer.name}</p>
                  <p className="text-sm text-foreground-600 mt-1">
                    <i className="ri-map-pin-line text-accent-500 mr-1.5"></i>
                    {farmer.village}
                  </p>
                  <p className="text-sm text-secondary-700 mt-1">
                    <i className="ri-plant-line mr-1.5"></i>
                    {farmer.crop}
                  </p>
                  <Link
                    to={`/farmers/${farmer.slug}`}
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Read {farmer.name}'s story
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 bg-background-50 rounded-lg border border-secondary-200 p-7 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 font-semibold">
              Our goal
            </h3>
            <p className="mt-4 text-base md:text-lg text-foreground-700 leading-relaxed">
              To create additional opportunities for farmers by connecting their farms and
              knowledge with people who want to learn, explore, and experience rural life.
            </p>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link
              to="/farmers"
              className="inline-flex items-center gap-2 bg-secondary-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Meet Our Farmers
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}